import React from "react";
import { Tabs } from "antd";
import RegisteredRestaurants from "./restaurant/RegisteredRestaurants";
import BlockedRestaurants from "./restaurant/BlockedRestaurants";
const { TabPane } = Tabs;

const Restaurants = () => {
    const onChange = (key) => {
      console.log(key);
    };
    const tabStyle = {
      color: "rgba(0, 0, 0, 0.65)",
      fontWeight:"600"
    };
  return (
    <>
      <Tabs
        defaultActiveKey="1"
        tabBarStyle={{ backgroundColor: "white" }}
        style={{
         
        }}
        onChange={onChange}
      >
        <TabPane
          tab={<span style={tabStyle}>Registered Restaurants</span>}
          key="1"
        >
          <>
            <RegisteredRestaurants />
          </>
        </TabPane>
        <TabPane
          tab={<span style={tabStyle}>Blocked Restaurants</span>}
          key="2"
        >
          <>
            <BlockedRestaurants />
          </>
        </TabPane>
      </Tabs>
    </>
  );
};

export default Restaurants;
